<template>
  <div class="detail-container">
    <h1 class="page-title">ユーザマスタ詳細</h1>
    <div v-if="user">
      <table class="table table-bordered">
        <tr>
          <th>ID</th>
          <td>{{ user.id }}</td>
        </tr>
        <tr>
          <th>ユーザ名</th>
          <td>{{ user.name }}</td>
        </tr>
        <tr>
          <th>メールアドレス</th>
          <td>{{ user.email }}</td>
        </tr>
        <tr>
          <th>社員印画像</th>
          <td>
            <img
              v-if="user.employee_seal_image_url"
              :src="user.employee_seal_image_url"
              class="employee-seal-image"
              alt="社員印画像"
            >
            <span v-else>未登録</span>
          </td>
        </tr>
        <tr>
          <th>現在システムの権限</th>
          <td>{{ roleLabel(user.role) }}</td>
        </tr>
        <tr>
          <th>システム別権限</th>
          <td>
            <div
              v-for="clientSystem in clientSystems"
              :key="clientSystem.key"
              class="mb-1"
            >
              {{ clientSystem.label }}: {{ roleLabel(user.roles_by_system?.[clientSystem.key]) }}
            </div>
          </td>
        </tr>
      </table>

      <div class="btn-area">
        <router-link :to="{ name: 'UserList', params: { id: user.id }, query: route.query }">
          <button type="button" class="btn btn-primary">一覧へ</button>
        </router-link>

        <router-link v-if="userRole == 0 || userRole == 999" :to="{ name: 'UserEdit', params: { id: user.id }, query: route.query }">
          <button type="button" class="btn btn-success mx-2">編集</button>
        </router-link>
      </div>
    </div>
    <div v-else>
      ユーザー情報を読み込み中...
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { getUser, getUserRoleCatalog } from '@/api/axios';

export default {
  setup() {
    const title = ref('ユーザ詳細');
    const store = useStore();
    const route = useRoute();
    const userRole = computed(() => store.state.userRole);
    const user = ref({});
    const userId = route.params.id;
    const clientSystems = ref([]);
    const roleOptions = ref([]);

    watchEffect(() => {
      document.title = title.value;
    });

    const roleLabel = (roleValue) => {
      const matched = roleOptions.value.find((option) => Number(option.value) === Number(roleValue));
      return matched?.label || roleValue || '-';
    };

    const fetchUser = async () => {
      const response = await getUser(userId);
      user.value = response.data;
    };

    const fetchRoleCatalog = async () => {
      const response = await getUserRoleCatalog();
      clientSystems.value = response.data.client_systems || [];
      roleOptions.value = response.data.role_options || [];
    };

    onMounted(async () => {
      await Promise.all([fetchUser(), fetchRoleCatalog()]);
    });

    return {
      title,
      userRole,
      user,
      route,
      clientSystems,
      roleLabel
    };
  }
};
</script>

<style scoped>
.employee-seal-image {
  display: block;
  width: 80px;
  height: 80px;
  object-fit: contain;
}
</style>
